export default {
  state: {},
  actions: {},
  mutations: {}
}
